import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getCurrentDayOfMonth } from "../utils/currentDate";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { day } = useParams<{ day: string }>();
  const currentDay = getCurrentDayOfMonth();

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            setRole(userDoc.data().role);
          }
        }
      } catch (error) {
        console.error("Error fetching role:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, []);

  console.log("ProtectedRoute rendered");

  if (loading) {
    return <div>Loading...</div>; // Show a loading indicator while fetching the role
  }

  if (role === "user" && parseInt(day || "0") > currentDay) {
    return <Navigate to="/access-denied" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;